import styles from "./path-info.module.css";
import { ReactComponent as SnowMobileIcon } from "../../assets/images/path-cat-snowmobiling.svg";
import { COLORS } from "../../constants/app.constants";
import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";
import { replaceWithBr } from "./utils";
import { useMapContext } from "../../hooks/use-map-context";
import { postMessage } from "../../utils/map.utils";
import { contextToPathCategoryId } from "../../utils/conversion.utils";
import { AppContentContext } from "../../enums/app.enums";

type Props = {
  id?: string;
  name: string;
  description: string;
  zones: string[];
  isStandAlone: boolean;
  onClose: () => void;
  isTour?: boolean;
};

export const SnowMobilePathInfo = ({
  id,
  name,
  description,
  zones,
  isStandAlone,
  onClose,
  isTour = false,
}: Props) => {
  const { useEnglish, showGpxSnowmobileDownload: gpxAllowed, mapPathCategories } = useMapContext();
  const snowmobileCategoryId = `${contextToPathCategoryId(AppContentContext.Snowmobiling)}`;
  const showGpxDownload = isTour && gpxAllowed && (mapPathCategories[snowmobileCategoryId]?.showGpxDownload ?? false); // Only show GPX download for tours, not individual paths
  const handleDownloadGpx = () => {
    if (!id || isStandAlone || !isTour) return;
    postMessage(JSON.stringify({ gpxSnowmobileDownload: true, trailId: id }));
  };
  const getZoneMetadata = (zone: string) => {
    if (useEnglish) {
      return zone === "high" ? "High zone" : "Low zone";
    }
    return zone === "high" ? "Högzon" : "Lågzon";
  };
  const uniqueZones = zones.filter(
    (value, index, array) => array.indexOf(value) === index
  );
  const zoneMetadata = uniqueZones
    .map((zone) => getZoneMetadata(zone))
    .join(", ");
  const metaData = zoneMetadata;

  return (
    <div
      className={
        isStandAlone
          ? styles.subPathInfoContainerStandAlone
          : styles.subPathInfoContainer
      }
      style={{ height: isStandAlone ? "400px" : "200px" }}
      id="sheet"
    >
      <div className={styles.header}>
        <div className={styles.handleWrapper} id="handle">
          <div className={styles.dragHandle} />
        </div>
        <div className={styles.headerInfoSection}>
          <div
            className={
              isStandAlone ? styles.iconContainer : styles.iconContainerMobile
            }
          >
            <SnowMobileIcon color={COLORS.PATHS.SNOWMOBILING} />
          </div>
          <div className={styles.headerRightCol}>
            <h1 className={isStandAlone ? styles.title : styles.titleMobile}>
              {name}
            </h1>
            <div className={styles.difficultyRow}>
              <div className={styles.difficultyText}>{metaData}</div>
            </div>
          </div>
          <CloseIcon className={styles.closeButton} onClick={onClose} />
        </div>
      </div>

      <div className={styles.descriptionContainer}>
        {showGpxDownload && !isStandAlone && id && (
          <button className={styles.gpxDownloadButton} onClick={handleDownloadGpx}>
            Ladda ner gpx
          </button>
        )}
        <div
          className={styles.snowmobilePathDescription}
          dangerouslySetInnerHTML={{
            __html: replaceWithBr(description),
          }}
        />
      </div>
    </div>
  );
};
